import {put,takeLatest,call} from 'redux-saga/effects';
import * as ordersService from "../../../services/orderService";
import {
    GET_PAST_ORDERS_OF_VENUE,
    GET_PAST_ORDERS_OF_VENUE_SUCCESS,
    GET_PAST_ORDERS_OF_VENUE_ERROR
}
    from "../../actions/order";
function* getPastOrdersOfVenueSaga(action) {
    try {
        const data=yield call(ordersService.GetPastOrdersOfVenue,action.payload)
        yield put({
            type: GET_PAST_ORDERS_OF_VENUE_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_PAST_ORDERS_OF_VENUE_ERROR,error: error.data
        });
    }
}

export function* getPastOrdersVenueSagaWatcher() {
    yield takeLatest(GET_PAST_ORDERS_OF_VENUE,getPastOrdersOfVenueSaga);
}